import { Search, X } from "lucide-react";
import { fmtDate } from "@/lib/format";

export const EventPicker = ({ events, reports, editId, value, search, setSearch, onPick }) => {
  const taken = new Set(reports.filter((r) => r.id !== editId).map((r) => r.event_id));
  const q = search.trim().toLowerCase();
  const avail = events
    .filter((e) => !taken.has(e.id) || e.id === value)
    .filter((e) => !q || [e.name, e.client, e.location, e.date, fmtDate(e.date)].filter(Boolean).some((v) => String(v).toLowerCase().includes(q)))
    .sort((a, b) => (b.date || "").localeCompare(a.date || ""));
  const selected = events.find((e) => e.id === value);
  return (
    <div className="space-y-2">
      <div className="relative">
        <Search className="w-4 h-4 text-slate-500 absolute left-3 top-1/2 -translate-y-1/2" />
        <input data-testid="report-event-search" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Cerca evento per nome, cliente, luogo o data…" className="inp" style={{ paddingLeft: "2.25rem" }} />
        {search && <button data-testid="report-event-search-clear" onClick={() => setSearch("")} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500"><X className="w-4 h-4" /></button>}
      </div>
      <select data-testid="report-event-select" value={value} onChange={(e) => onPick(e.target.value)} className="inp">
        <option value="">{avail.length ? `— Seleziona evento (${avail.length} disponibili) —` : "— Nessun evento libero trovato —"}</option>
        {selected && !avail.includes(selected) && <option value={selected.id}>{selected.name} ({fmtDate(selected.date)})</option>}
        {avail.map((e) => <option key={e.id} value={e.id}>{e.name} ({fmtDate(e.date)})</option>)}
      </select>
      <p className="text-[10px] text-slate-600">Sono mostrati solo gli eventi non ancora collegati a un altro report.</p>
    </div>
  );
};
